<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Lista de cidadãos cadastrados últimos 7 dias"
    >
        <List />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

export default {
    components: {List},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
}
</script>